/**
 * PersonEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { RegionMemberEntity } from "../RegionMemberEntity";
import { ProjectMemberEntity } from "../ProjectMemberEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { VisitMemberEntity } from "../VisitMemberEntity";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
import { RemarkEntity } from "../RemarkEntity";
import { SignatureEntity } from "../SignatureEntity";
import { PersonEntity } from "../PersonEntity";
declare global {
    interface EntityTypeMap {
        Person: PersonEntity;
    }
}
export abstract class PersonGeneratedEntity extends BaseEntity {
    public abstract personId: string;
    public abstract templateId: string | null;
    public abstract contactID: string | null;
    public abstract name: string | null;
    public abstract email: string | null;
    public abstract abbreviation: string | null;
    public abstract address: string | null;
    public abstract company: string | null;
    public abstract displayName: string | null;
    public abstract phone: string | null;
    public abstract notes: string | null;
    public abstract temp: boolean;
    public abstract project: ProjectEntity;
    public abstract readonly memberOfRegions: ReadonlyArray<RegionMemberEntity>;
    public abstract readonly memberOfProject: ReadonlyArray<ProjectMemberEntity>;
    public abstract readonly memberOfWorkPackage: ReadonlyArray<WorkPackageEntity>;
    public abstract readonly memberOfVisit: ReadonlyArray<VisitMemberEntity>;
    public abstract visitorInRemarkCategory: RemarkCategoryEntity | null;
    public abstract readonly contactOfRemark: ReadonlyArray<RemarkEntity>;
    public abstract readonly signatures: ReadonlyArray<SignatureEntity>;
}
